/*
 * Browsing signals for integrated1 customer intelligence, with tracking
 * consent only (Shopify Customer Privacy API: analytics or marketing), sent
 * to the CRM app (product-intent tracker data-api-base + /apps/intent/browse),
 * which checks consent and every field again.
 *
 * - Search page: the query, the number of results and the products shown
 *   (once, on the first results page), then the products opened from them.
 * - Predictive search: the product picked for the typed query.
 * - Collection and look pages: one beacon when the visit had real attention,
 *   i.e. at least 20 s active and 40% of the page scrolled, or an interaction
 *   (filter or sort, product opened, add to cart or "add the look", next page).
 * - Blog article: one beacon when it was read (30 s active and 50% scrolled)
 *   or a product or collection it cites was opened, with what it cites.
 *
 * The page data comes from <script type="application/json" data-browse-intent>
 * rendered by sections/main-collection.liquid, sections/main-search.liquid,
 * snippets/outfit-page-body.liquid and sections/main-article.liquid.
 * The last query of the session is kept (with consent) for "Scelti per te".
 */
(function () {
  "use strict";

  if (window.__skisisesBrowseIntent) return;
  window.__skisisesBrowseIntent = true;

  var THRESHOLDS = { collection: [20, 40], look: [20, 40], article: [30, 50] };   // [active seconds, scroll %]
  var IDLE_MS = 30000;
  var LAST_SEARCH_KEY = "sks:last-search";

  function privacy() {
    var api = window.Shopify && window.Shopify.customerPrivacy;
    function allowed(name) {
      try { return Boolean(api && typeof api[name] === "function" && api[name]()); } catch (e) { return false; }
    }
    return {
      analyticsProcessingAllowed: allowed("analyticsProcessingAllowed"),
      marketingAllowed: allowed("marketingAllowed"),
      preferencesProcessingAllowed: allowed("preferencesProcessingAllowed"),
      saleOfDataAllowed: allowed("saleOfDataAllowed"),
    };
  }

  function trackingAllowed(status) {
    return status.analyticsProcessingAllowed || status.marketingAllowed;
  }

  function endpoint() {
    var script = document.querySelector("script[data-api-base]");
    var base = script && script.getAttribute("data-api-base");
    return base ? base.replace(/\/+$/, "") + "/apps/intent/browse" : "";
  }

  function browserContext() {
    try {
      var tracker = window.IntegratedProductIntent;
      var ctx = tracker && typeof tracker.getBrowserContext === "function" ? tracker.getBrowserContext() : null;
      if (ctx) return ctx;
    } catch (e) { /* the tracker is optional */ }
    return {};
  }

  function send(body) {
    var status = privacy();
    if (!trackingAllowed(status)) return false;
    var url = endpoint();
    var ctx = browserContext();
    if (!url || !(ctx.visitorId || ctx.sessionId || ctx.shopifyClientId)) return false;
    var payload = JSON.stringify(Object.assign({
      shopDomain: window.Shopify && window.Shopify.shop,
      visitorId: ctx.visitorId || undefined,
      sessionId: ctx.sessionId || undefined,
      shopifyClientId: ctx.shopifyClientId || undefined,
      customerPrivacyStatus: status,
      locale: document.documentElement.lang || undefined,
      url: window.location.pathname,
      occurredAt: new Date().toISOString(),
    }, body));
    try {
      if (navigator.sendBeacon && navigator.sendBeacon(url, new Blob([payload], { type: "text/plain" }))) return true;
    } catch (e) { /* fall back to fetch */ }
    try {
      fetch(url, { method: "POST", mode: "cors", keepalive: true, headers: { "Content-Type": "text/plain" }, body: payload }).catch(function () {});
    } catch (e) { return false; }
    return true;
  }

  // The tracker and the Customer Privacy API may load after this script.
  function whenReady(fn, tries) {
    tries = tries || 0;
    var ctx = browserContext();
    var ready = window.Shopify && window.Shopify.customerPrivacy && endpoint() && (ctx.visitorId || ctx.sessionId || ctx.shopifyClientId);
    if (ready || tries >= 12) return fn();
    setTimeout(function () { whenReady(fn, tries + 1); }, 400);
  }

  function rememberSearch(query) {
    if (!query || !trackingAllowed(privacy())) return;
    try { sessionStorage.setItem(LAST_SEARCH_KEY, JSON.stringify({ q: query, at: Date.now() })); } catch (e) { /* storage blocked */ }
  }

  function pageData() {
    var node = document.querySelector("script[data-browse-intent]");
    if (!node) return null;
    try { return JSON.parse(node.textContent || "{}"); } catch (e) { return null; }
  }

  function handleOf(link) {
    var card = link.closest && link.closest("product-card[handle]");
    if (card) return card.getAttribute("handle");
    var match = (link.getAttribute("href") || "").match(/\/products\/([^/?#]+)/);
    return match ? decodeURIComponent(match[1]) : null;
  }

  /* ------------------------------------------------------------------ predictive search */
  document.addEventListener("click", function (event) {
    var link = event.target.closest && event.target.closest("predictive-search a[href*='/products/']");
    if (!link) return;
    var holder = link.closest("[data-product-id]");
    var input = document.querySelector("#predictive-search-form input[name='q']");
    var query = input && input.value ? input.value.trim() : "";
    if (!holder || !query) return;
    rememberSearch(query);
    send({ kind: "search", source: "predictive", query: query, clickedProductIds: [holder.getAttribute("data-product-id")] });
  }, true);

  /* ------------------------------------------------------------------ search and collection pages */
  var data = pageData();
  if (!data || ["search", "collection", "look", "article"].indexOf(data.kind) < 0) return;

  var ids = {};
  (data.products || []).forEach(function (pair) { if (pair && pair[1]) ids[pair[1]] = String(pair[0]); });
  var shown = (data.products || []).map(function (pair) { return String(pair[0]); }).slice(0, 24);

  var state = { active: 0, scroll: 0, filters: 0, adds: 0, pages: 0, opened: 0, clicked: [], lastActivity: Date.now(), sent: false };

  // Article: the products and collections it cites (text links and the merchandising block).
  var cited = { products: [], collections: [] };
  if (data.kind === "article") {
    document.querySelectorAll(".prose a[href]").forEach(function (a) {
      var href = a.getAttribute("href") || "";
      var product = href.match(/\/products\/([a-z0-9-]+)/i);
      var collection = href.match(/\/collections\/([a-z0-9-]+)(?:[/?#]|$)/i);
      if (product && cited.products.indexOf(product[1]) < 0 && cited.products.length < 24) cited.products.push(product[1].toLowerCase());
      if (collection && collection[1] !== "all" && cited.collections.indexOf(collection[1]) < 0 && cited.collections.length < 24) {
        cited.collections.push(collection[1].toLowerCase());
      }
    });
  }

  function markActive() { state.lastActivity = Date.now(); }
  ["pointermove", "keydown", "scroll", "click", "touchstart"].forEach(function (name) {
    window.addEventListener(name, markActive, { passive: true });
  });
  window.addEventListener("scroll", function () {
    var room = document.documentElement.scrollHeight - window.innerHeight;
    if (room > 0) state.scroll = Math.max(state.scroll, Math.min(100, Math.round((window.scrollY / room) * 100)));
  }, { passive: true });
  setInterval(function () {
    if (document.visibilityState === "visible" && Date.now() - state.lastActivity < IDLE_MS) state.active += 1;
  }, 1000);

  document.addEventListener("facet:update", function () { state.filters += 1; });
  document.addEventListener("variant:add", function () { state.adds += 1; });
  var PRODUCT_LINKS = {
    search: "product-list a[href*='/products/'], .product-list a[href*='/products/']",
    collection: "product-list a[href*='/products/'], .product-list a[href*='/products/']",
    look: ".op-wrap a[href*='/products/']",
    article: ".prose a[href*='/products/'], .prose a[href*='/collections/']",
  }[data.kind];
  document.addEventListener("click", function (event) {
    var target = event.target;
    if (!target.closest) return;
    var link = target.closest(PRODUCT_LINKS);
    if (link && !link.closest("predictive-search")) {
      state.opened += 1;
      var id = ids[handleOf(link)];
      if (id && state.clicked.indexOf(id) < 0 && state.clicked.length < 12) state.clicked.push(id);
      return;
    }
    if (data.kind === "look" && target.closest(".op-add-all, .op-wrap button[onclick*='add'], .op-wrap button[name='add']")) {
      state.adds += 1;
      return;
    }
    if (target.closest(".pagination a, a[href*='page=']")) state.pages += 1;
  }, true);

  function engaged() {
    var threshold = THRESHOLDS[data.kind] || THRESHOLDS.collection;
    var interactions = state.filters + state.opened + state.adds + state.pages;
    return (state.active >= threshold[0] && state.scroll >= threshold[1]) || interactions >= 1;
  }

  function filters() {
    var out = {};
    new URLSearchParams(window.location.search).forEach(function (value, key) {
      if (key.indexOf("filter.") === 0) (out[key] = out[key] || []).push(value);
    });
    return out;
  }

  function flush() {
    if (state.sent) return;
    var engagement = { activeSeconds: state.active, scrollPercent: state.scroll, filterChanges: state.filters,
                       productClicks: state.opened, addsToCart: state.adds, pageChanges: state.pages };
    if (data.kind === "collection" || data.kind === "look") {
      if (!engaged()) return;
      state.sent = send(Object.assign({ kind: data.kind, handle: data.handle, productIds: shown, clickedProductIds: state.clicked },
                                      data.kind === "collection" ? { filters: filters() } : {}, engagement));
    } else if (data.kind === "article") {
      if (!engaged()) return;
      state.sent = send(Object.assign({ kind: "article", handle: data.handle, blog: data.blog,
                                        tags: (data.tags || []).filter(function (t) { return String(t).indexOf(":") < 0; }),
                                        productHandles: cited.products, collectionHandles: cited.collections }, engagement));
    } else if (state.clicked.length) {
      state.sent = send({ kind: "search_engagement", query: data.query, clickedProductIds: state.clicked });
    }
  }

  window.addEventListener("pagehide", flush);
  document.addEventListener("visibilitychange", function () { if (document.visibilityState === "hidden") flush(); });

  if (data.kind === "search" && data.query) {
    whenReady(function () {
      rememberSearch(data.query);
      if (!data.page || data.page === 1) {
        send({ kind: "search", source: "results", query: data.query, resultsCount: data.resultsCount, productIds: shown });
      }
    });
  }
})();
